import { getStoreValueForParam } from './getStoreValueForParam'

/**
 * Returns the current store value for a schema param (mirrors getStoreValueForParam).
 */
export function getCurrentValueForSchemaParam(schemaKey, settingsKey, state) {
  return getStoreValueForParam(schemaKey, settingsKey, state)
}
